import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import SingleProject from "./pages/SingleProject";
import PrivateRoutes from "./routes/PrivateRoutes";
import Login from "./pages/Login";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useState, useEffect } from "react";
import Sweeps from "./pages/Sweeps";
import Clients from "./pages/Clients";
import EditClient from "./pages/EditClient";
import CreateClient from "./pages/CreateClient";
import Vendors from "./pages/Vendors";
import CreateVendor from "./pages/CreateVendor";
import VendorDetails from "./pages/VendorDetails";
import CreateCampaign from "./pages/CreateCampaign";
import EditCampaign from "./pages/EditCampaign";
import Leads from "./pages/Leads";
import LeadDetails from "./pages/LeadDetails";
import Verticals from "./pages/Verticals";
import VerticalClients from "./pages/VerticalClients";
import AuthWrapper from "./components/AuthWrapper";
import Reporting from "./pages/Reporting";
import NewReportingInternal from "./pages/NewReportingInternal";
import MyProtectedhomeClicks from "./pages/MyProtectedhomeClicks";
import Partners from "./pages/Partners";

function App() {
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    message: "",
    type: undefined,
  });
  const [isMobile, setIsMobile] = useState(false);

  const [startDate, setStartDate] = useState<Date | null>(() => {
    const storedStartDate = sessionStorage.getItem("startDate");
    return storedStartDate
      ? new Date(storedStartDate)
      : new Date(new Date().setMonth(new Date().getMonth() - 1));
  });
  const [endDate, setEndDate] = useState<Date | null>(() => {
    const stored = sessionStorage.getItem("endDate");
    return stored ? new Date(stored) : new Date();
  });

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);
    sessionStorage.setItem("startDate", date ? date.toISOString() : "");
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(date);
    sessionStorage.setItem("endDate", date?.toISOString() || "");
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 999); // You can adjust the width threshold as needed
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return (
    <div style={{ display: "flex" }} className="App">
      {isMobile ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "24px",
            fontWeight: "bold",
            color: "#013566",
          }}
        >
          This page is not yet available on mobile devices
        </div>
      ) : (
        <>
          {" "}
          <BrowserRouter>
            <AuthWrapper setSnackbar={setSnackbar} />
            <Routes>
              <Route path="/" element={<Login setSnackbar={setSnackbar} />} />
              <Route element={<PrivateRoutes setSnackbar={setSnackbar} />}>
                <Route
                  path="/dashboard"
                  element={
                    <Dashboard
                      startDate={startDate}
                      endDate={endDate}
                      handleStartDateChange={handleStartDateChange}
                      handleEndDateChange={handleEndDateChange}
                    />
                  }
                />
                <Route
                  path="/website/:id"
                  element={
                    <SingleProject
                      startDate={startDate}
                      endDate={endDate}
                      handleStartDateChange={handleStartDateChange}
                      handleEndDateChange={handleEndDateChange}
                    />
                  }
                />
                <Route
                  path="/sweeps"
                  element={
                    <Sweeps
                      startDate={startDate}
                      endDate={endDate}
                      handleStartDateChange={handleStartDateChange}
                      handleEndDateChange={handleEndDateChange}
                    />
                  }
                />
                <Route path="/clients" element={<Clients />} />
                <Route path="/partners" element={<Partners />} />
                <Route
                  path="/clients/create"
                  element={<CreateClient setSnackbar={setSnackbar} />}
                />
                <Route
                  path="/clients/:id/edit"
                  element={<EditClient setSnackbar={setSnackbar} />}
                />
                <Route path="/vendors" element={<Vendors />} />
                <Route
                  path="/vendors/create"
                  element={<CreateVendor setSnackbar={setSnackbar} />}
                />
                <Route
                  path="/vendors/:id"
                  element={<VendorDetails setSnackbar={setSnackbar} />}
                />
                <Route
                  path="/vendors/:id/campaigns/create"
                  element={<CreateCampaign setSnackbar={setSnackbar} />}
                />
                <Route
                  path="/vendors/:id/campaigns/:campaignId/edit"
                  element={<EditCampaign setSnackbar={setSnackbar} />}
                />
                <Route path="/leads" element={<Leads />} />
                <Route path="/leads/:id" element={<LeadDetails />} />
                <Route path="/reporting" element={<Reporting />} />
                <Route
                  path="/new-reporting-internal"
                  element={<NewReportingInternal />}
                />
                <Route
                  path="/myprotectedhome-clicks"
                  element={<MyProtectedhomeClicks />}
                />
                <Route
                  path="/verticals"
                  element={<Verticals setSnackbar={setSnackbar} />}
                />
                <Route
                  path="/verticals/:id/clients"
                  element={<VerticalClients />}
                />
              </Route>
            </Routes>
          </BrowserRouter>
          {snackbar.isOpen && (
            <Snackbar
              open={snackbar.isOpen}
              autoHideDuration={3000}
              onClose={() =>
                setSnackbar({ isOpen: false, message: "", type: undefined })
              }
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              sx={{ width: "340px" }}
            >
              <Alert
                onClose={() =>
                  setSnackbar({ isOpen: false, message: "", type: undefined })
                }
                severity={snackbar.type}
                variant="filled"
                sx={{ width: "100%" }}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>
          )}
        </>
      )}
    </div>
  );
}

export default App;
